const ASSESSMENTS_GRID_COLUMNS = "300px 1fr";

export { ASSESSMENTS_GRID_COLUMNS };
